<template>
  <div
    class="settings-row settings-row-xs"
    data-test="graphics-verticalAlignSettings"
  >
    <span
      v-if="!hideLabel"
      class="sidebar-form-label"
    >{{ label }}</span>
    <div class="settings-col-12 settings-col-xs">
      <div
        class="btn-group vertical-alignments"
        role="group"
        :aria-label="label"
      >
        <button
          v-for="align in verticalAlignments"
          :key="align"
          name="valign"
          type="button"
          :class="[{ selected: _align === align }]"
          class="btn btn-sm"
          :data-test="`graphics-${action}-${align}`"
          :data-entity="`graphics-${action}-${align}`"
          @click="setVerticalAlignment(align)"
        >
          <span
            :class="`fak fa-text-align-${align}`"
          />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VerticalAlignSettings',
  emits: ['update:modelValue'],
  props: {
    modelValue: {
      required: true,
      type: String,
      default: 'middle',
    },
    action: {
      type: String,
      default: 'updateVerticalAlignment',
    },
    label: {
      type: String,
      default: 'Item Vertical Alignment',
    },
    hideLabel: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      verticalAlignments: ['top', 'middle', 'bottom'],
    };
  },
  computed: {
    _align: {
      get() {
        return this.modelValue;
      },
      set(v) {
        this.$emit('update:modelValue', v);
      },
    },
  },
  methods: {
    setVerticalAlignment(align) {
      // eslint-disable-next-line no-underscore-dangle
      this._align = align;
    },
  },
};
</script>
